module.exports = __webpack_public_path__ + "static/media/AIA.e3d0530a.png";